import React from 'react';
import { Link } from 'react-router-dom';

const Navigation = () => {
  return (
    <header className='simple-nav'>
      <nav className='nav-inner' style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', maxWidth: '1100px', margin: '0 auto', width: '100%'}}>
        <div className='nav-left'>
          <Link to='/blog' className='site-title'>M. Derylo — Research Blog</Link>
        </div>

        <ul className='nav-links' style={{listStyle: 'none', display: 'flex', gap: '1rem', margin: 0, padding: 0}}>
          <li><a href='https://github.com/mderylo' target='_blank' rel='noopener noreferrer'>GitHub</a></li>
          <li><a href='/Resume.pdf' target='_blank' rel='noopener noreferrer'>CV</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Navigation;